export default class Header {
  constructor() {
    const btnAction = document.querySelectorAll('.action-menu')
    const blockToggle = document.querySelectorAll('.block-toggle')
    const itemHasChildren = document.querySelectorAll('.menu-item-has-children')
    const btnLanguages = document.querySelector(
      '#language_list .current_language'
    )
    const contentLanguages = document.querySelector('#language_list .list')

    btnAction.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelector('.header-main').classList.toggle('close-state')
        document.querySelector('body').classList.toggle('block')

        blockToggle.forEach(function (block) {
          block.classList.toggle('active')
        })

        if (document.querySelector('.menu-item.active')) {
          document.querySelector('.menu-item.active').classList.remove('active')
          document
            .querySelector('.sub-menu-wrap.active')
            .classList.remove('active')
        }

        if (contentLanguages) {
          contentLanguages.classList.remove('active')
        }
      })
    })

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.menu-item, .sub-menu-wrap, .btn-action, .block')) {
        document.querySelectorAll('.menu-item.active, .sub-menu-wrap.active, .block.active')
          .forEach(el => el.classList.remove('active'));
    
        document.querySelector('.header-main').classList.remove('close-state');
        document.querySelector('body').classList.remove('block');
      }
    });

    itemHasChildren.forEach(function (item) {
      item.addEventListener('click', function () {
        setTimeout(function() {
          const subMenu = this.querySelector('.sub-menu-wrap.active');
          const subMenuUl = this.querySelector('ul.sub-menu');
          subMenuUl.classList.remove('add-scroll');
      
          const subMenuHeight = subMenu.offsetHeight + 100;
          const screenHeight = window.innerHeight;
  
          if (screenHeight < subMenuHeight) {
              subMenuUl.classList.add('add-scroll');
          }else {
              subMenuUl.classList.remove('add-scroll');
          }
        }.bind(this), 10)


        let itemActive = document.querySelector('.menu-item.active')

        if (itemActive && !item.classList.contains('active')) {
          console.log('desabilita outro, habilita esse')

          document.querySelector('.menu-item.active').classList.remove('active')
          document
            .querySelector('.sub-menu-wrap.active')
            .classList.remove('active')

          this.querySelector('.sub-menu-wrap').classList.toggle('active')
          this.classList.toggle('active')
        } else if (itemActive && item.classList.contains('active')) {
          document.querySelector('.menu-item.active').classList.remove('active')
          document
            .querySelector('.sub-menu-wrap.active')
            .classList.remove('active')
        } else {
          if (contentLanguages) {
            contentLanguages.classList.remove('active')
          }

          this.querySelector('.sub-menu-wrap').classList.toggle('active')
          this.classList.toggle('active')
        }
      })
    })

    if (btnLanguages) {
      btnLanguages.addEventListener('click', function () {
        this.classList.toggle('active')
        contentLanguages.classList.toggle('active')

        if (window.screen.width >= 1024) {
          if (document.querySelector('.sub-menu-wrap.active')) {
            document
              .querySelector('.sub-menu-wrap.active')
              .classList.remove('active')
          }
          if (document.querySelector('.menu-item-has-children.active')) {
            document
              .querySelector('.menu-item-has-children.active')
              .classList.remove('active')
          }
          blockToggle.forEach(function (block) {
            if (block.classList.contains('active')) {
              block.classList.remove('active')
            }
          })

          document.querySelector('.header-main').classList.remove('close-state')
        }
      })
    }
    function updateSubMenuScrollClass() {
      setTimeout(function() {
        const subMenu = document.querySelector('.sub-menu-wrap.active');
        const subMenuUl = document.querySelector('.sub-menu-wrap.active ul.sub-menu');

        if(subMenuUl){
          if(subMenuUl.classList.contains('add-scroll')){
            subMenuUl.classList.remove('add-scroll');
  
          }   
        }   
        if (subMenu) {
          const subMenuHeight = subMenu.offsetHeight + 100;
          const screenHeight = window.innerHeight;
          console.log(subMenuHeight, screenHeight)

          if (screenHeight < subMenuHeight) {
            subMenuUl.classList.add('add-scroll');
          } else {
            subMenuUl.classList.remove('add-scroll');
          }
        }
      }, 100)
  }
  window.addEventListener('resize', updateSubMenuScrollClass);
  }
}
